import axios from 'axios'
import { Notify, Toast, Dialog } from 'vant';
import { getToken, removeToken } from '@/utils/auth'
import { router } from '@/router'

const base_url = process.env.VUE_APP_API;
const tokenKey = process.env.VUE_APP_TOKEN_KEY;

// 创建axios实例
const service = axios.create({
  baseURL: base_url, // 接口地址根路径
  timeout: 1000 * 60, // 请求超时时间 60秒
  withCredentials: true, // 跨域请求允许携带cookie
  openLoading: true, // 自定义配置是否开启加载效果
})

// request拦截器
service.interceptors.request.use(config => {
  // 让每个请求携带自定义token 请根据实际情况自行修改
  let token = getToken();
  if (token) {
    config.headers[tokenKey] = token;
  }

  // 请求头添加childCode
  const currentRouter = router.app.$route;
  // console.log(currentRouter)
  const childCode = currentRouter.meta.childCode;
  if (childCode) {
    config.headers['childCode'] = childCode;
  }

  // 开启加载效果
  if (config.openLoading) {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0, // 值为 0 时，toast 不会消失
    });
  }

  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    // console.log(response)
    // 关闭加载效果
    if (response.config.openLoading) {
      Toast.clear();
    }

    // code为非200是抛错 可结合自己业务进行修改
    const res = response.data
    // 处理多种状态值
    res.status = res.status ? res.status : res.code;
    if (res.status == 1) {
      res.status = '200'
    }
    // 无登录状态401
    if (res.status == 401) {
      Dialog.alert({
        title: '登录失效',
        message: '当前登录状态已失效，请重新登录！',
        confirmButtonText: '去登录'
      }).then(() => {
        removeToken();
        location.reload();
      });
    } else if (res.status == 500) {
      const errMsg = res.errors[0].message;
      Notify({
        message: errMsg,
        type: 'danger'
      })
      return Promise.reject(new Error(errMsg))
    } else if (res.status != 200) {
      const errMsg = res.errors[0]?.message || '数据异常';
      Toast.fail({
        message: errMsg,
        forbidClick: true
      })
      return Promise.reject(res)
    }

    return res
  },
  error => {
    console.log('err' + error)// for debug
    Notify({
      message: error.message,
      type: 'danger'
    })
    // 关闭加载效果
    if (error.config.openLoading) {
      Toast.clear();
    }
    return Promise.reject(error)
  }
)

export default service
